import React from 'react';
import { getExternalApplicationDisplayLines } from '../../utils/applicationDisplayFormat';

export type ExternalApplicationCellFields = {
  externalNumber?: string | null;
  basisDate?: string | null;
  applicationDate?: string | null;
};

export type ExternalApplicationCellProps = {
  application: ExternalApplicationCellFields;
  /** Блок в Descriptions карточки: обе строки одного кегля, без серой мелкой даты. */
  forDescriptionCard?: boolean;
};

/** Две строки: внешний № и дата (basisDate / applicationDate). */
export const ExternalApplicationCell: React.FC<ExternalApplicationCellProps> = ({
  application,
  forDescriptionCard,
}) => {
  const { line1, line2 } = getExternalApplicationDisplayLines(application);
  if (forDescriptionCard) {
    return (
      <div className="application-card-id-block">
        <div className="application-card-id-block__line1">{line1}</div>
        <div className="application-card-id-block__line2">{line2}</div>
      </div>
    );
  }
  return (
    <>
      <div className="primary-cell">{line1}</div>
      <div className="secondary-text">{line2}</div>
    </>
  );
};

export default ExternalApplicationCell;
